webpackJsonp([269473319772990],{

/***/ 1232:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"slug":"/es/suggestions/","langKey":"es"}}

/***/ })

});


// WEBPACK FOOTER //
// path---es-suggestions-97ff1cac38129ff00243.js